// Pagination.jsx
import React from "react";
import ReactPaginate from "react-paginate";
import "../styles/pagination.css";
import { useMediaQuery } from "react-responsive";

const Pagination = ({ pageCount, handlePageChange, currentPage }) => {
 
    const isDesktop = useMediaQuery({ minWidth: 768 });
  
 
 
  return (
        <div className="d-flex  paginate-container1 mt-3">
    <div>
      <ReactPaginate
        breakLabel="..."
        nextLabel={isDesktop ? "Next >" : " >"}
        previousLabel={isDesktop ? "< Previous" : "<"}
        onPageChange={handlePageChange}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        renderOnZeroPageCount={null}
        containerClassName="pagination1"
        pageLinkClassName="page-num"
        previousLinkClassName="page-num"
        nextLinkClassName="page-num"
        activeLinkClassName="active"
        disabledClassName="disabled"
        forcePage={currentPage}
      />
    </div>  
        </div>

  );
};

export default Pagination;
